import React from "react"
import shape1 from "../../images/our-mission/our-mission-shape1.png"
import shape2 from "../../images/our-mission/our-mission-shape2.png"
import { getBackgroundClass, getLayoutClass } from "../../utils/sectionHelpers";
import DynamicImage from "../common/DynamicImage";
import { HighlightText } from "../common/HighlightText";

const SupportContact = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  const layoutClass = getLayoutClass(settings.layout);
  return (
    <>
      <section className={`our-mission-area ptb-70 contact-support-area ${backgroundClass}`}>
        <div className="container">
          <div className={`row align-items-center gy-4 gx-lg-5 ${layoutClass}`}>
            <div className="col-lg-6 col-md-12 order-1">
              <div className="our-mission-content">
                <div className="content">
                  {data.title && <h2><HighlightText content={data.title} /></h2>}
                  {data?.description?.map((block, index) => {
                    switch (block.type) {
                      case "paragraph":
                        return (
                          <p key={index}>
                            <HighlightText content={block.children.map(c => c.text).join("")} />
                          </p>
                        );

                      case "heading":
                        const Tag = `h${block.level}`;
                        return (
                          <Tag key={index} className="mt-4 mb-3">
                            <HighlightText content={block.children.map(c => c.text).join("")} />
                          </Tag>
                        );

                      case "list":
                        return (
                          <ul key={index} className="our-mission-list contact-support-list">
                            {block.children.map((item, i) => (
                              <li key={i}>
                                  <i className="flaticon-tick"></i>{" "}
                                  {item.children.map(c => c.text).join("")}
                                  <img src={shape2} alt="banner" />
                              </li>
                            ))}
                          </ul>
                        );

                      default:
                        return null;
                    }
                  })}
                </div>
              </div>
            </div>

            {data?.image?.[0] && (
              <div className="col-lg-6 col-md-12 order-2">
                <div className="our-mission-image">
                 <DynamicImage image={data.image[0]} />
                  <div className="shape">
                    <img src={shape1} alt="banner" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default SupportContact
